import React from 'react';
// material
import { Box } from '@mui/material';
import { useSelector } from "react-redux";
import { AppState } from "../Common/Reducer/rootReducerTypes";
import useLocalStorage from '../hooks/useLocalStorage';
import { useNavigate } from 'react-router-dom';
import useBackendData from '../hooks/useBackendData';
import { buildHttpHeaders } from '../utils/buildHttpHeaders';

// ----------------------------------------------------------------------

export default function Logo() {
  const user = useSelector((state: AppState) => state.user);
  const [selectedClient] = useBackendData();
  const [defaultLogoUri, setDefaultLogoUri] = useLocalStorage(`logoUri_${selectedClient.name}`, undefined);
  const navigate = useNavigate();

  const [currentSrc, setCurrentSrc] = React.useState(defaultLogoUri || '');
  const [loading, setLoading] = React.useState(true);

  const handleLogoClick = () => {
    navigate({
      pathname: '/',
    });
  }

  React.useEffect(() => {
    if (!user || !selectedClient?.name) return;

    setLoading(true);

    fetch('settings/logo', { headers: buildHttpHeaders(selectedClient.name) })
      .then(response => response.text())
      .then(result => {
        const imageToLoad = new Image();
        const base64 = result.trim().replace(/^["']|["']$/g, '');
        var imageSrc = `data:image/png;base64,${base64}`;

        imageToLoad.src = imageSrc;
        imageToLoad.onload = () => {
          // When image is loaded replace the src and set loading to false
          setLoading(false);
          setCurrentSrc(imageSrc);
          setDefaultLogoUri(imageSrc);
        }
      }).catch(err => {
        console.error('Error fetching logo:', err);
        setLoading(false);
      });
  }, []);

  return (
    <Box>
      {currentSrc && currentSrc.length > 0 &&
        <img
          src={currentSrc}
          style={{
            opacity: loading ? 0.5 : 1,
            transition: "opacity .15s linear",
            cursor: 'pointer'
          }}
          width="100%" height="100%"
          onClick={handleLogoClick}
        />
      }
    </Box>
  );
}